<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-6">
                <p>Support desk</p>
                <a class="footer__contact" href="tel:+56442081228" target="_blank">
                  <img style="margin-top: -10px;" src="../../../assets/img/phone.png">
                  Mesa de ayuda:
                  +56 44 208 1228
                </a>
                <a class="footer__contact" target="_blank" href="https://bhp.service-now.com/sp?id=sc_cat_item&sys_id=4b63e79adb6a43004b46fc1dbf9619ec">
                  <img style="margin-top: -10px;" src="../../../assets/img/mail.png"> Levantar incidente en Service Now
                </a>
                <!-- <a href="#" title="FAQ">Frequently asked questions</a> -->
            </div>
            <div class="col-12 col-lg-6">
                <p class="footer__copy">© BHP 2022 </p>
            </div>
            <div class="col-12 col-lg-6" *ngIf="shouldShowRole">
                <p style="color: yellow">{{employeeType}}</p>
                <p style="color: yellow">{{roleText}}</p>
            </div>
        </div>
    </div>
</footer>
